<template>
  <v-container>
    <v-app-bar
      app
      tile
      flat
      class="white"
      style="height: auto; border-bottom: 1.3px solid #f2f2f2 !important"
    >
      <PollsMenu />
      <v-spacer />

      <v-toolbar-title>
        <Logo :isDisabled="true" />
      </v-toolbar-title>
      <v-spacer />

      <v-btn depressed @click="logout" color="error">logout</v-btn>
    </v-app-bar>

    <v-overlay :value="overlay"
      ><v-progress-circular indeterminate size="64"></v-progress-circular
    ></v-overlay>

    <v-snackbar top :color="snackbar.color" v-model="snackbar.model">{{
      snackbar.msg
    }}</v-snackbar>

    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card class="mx-auto pa-8">
        <v-list-item class="text-center">
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <h2 class="primary--text">Change Password</h2>
            </v-list-item-title>
            <p>
              Your password has expired and you need to change it before you can
              proceed.
            </p>
          </v-list-item-content>
        </v-list-item>

        <ChangePasswordForm @onPasswordChange="handlePasswordChange" />
      </v-card>
    </v-dialog>

    <v-row class="pa-3" v-if="!overlay">
      <v-col class="mx-auto" cols="12" sm="10" md="8">
        <Message v-if="$route.query.status" />
        <Analytics v-else-if="voterData.analytics" />
        <Vote v-else-if="voterData.poll" />

        <v-alert outlined type="info" text v-else-if="voterData.message">
          {{
            (voterData.overview && voterData.overview.status) || "Info"
          }}!<br />
          {{ voterData.message }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { Analytics } from "@/components/organizer";
import { Vote, Message, PollsMenu } from "@/components/voter";
import { toSentenceCase } from "@/helpers";
import Logo from "@/components/Logo.vue";
import ChangePasswordForm from "@/components/ChangePasswordForm.vue";

export default {
  name: "VotePage",

  components: { ChangePasswordForm, Analytics, Vote, Message, Logo, PollsMenu },

  data: () => ({
    overlay: false,
    dialog: false,

    snackbar: {
      model: false,
      msg: "Error!",
    },
  }),

  computed: {
    voterData() {
      return this.$store.getters.getCollection("voterData");
    },

    brandName() {
      return process.env.VUE_APP_BRAND_NAME;
    },
  },

  methods: {
    toSentenceCase,
    ...mapActions(["makeFetch", "updateCollection"]),

    showSnackbar(event) {
      this.snackbar.msg = !event.pre ? toSentenceCase(event.msg) : event.msg;
      this.snackbar.color = event.color;
      this.snackbar.model = true;
    },

    handlePasswordChange(event) {
      if (event) {
        const { success } = event;
        this.dialog = !success;

        this.showSnackbar({
          msg: success ? event.data.message : event.message,
          color: success ? "primary" : "error",
        });

        const usr = JSON.parse(localStorage.getItem("usr"));
        usr.password_set = true;
        localStorage.setItem("usr", JSON.stringify(usr));
      } else {
        this.showSnackbar({
          msg: "A problem occurred while changing your password. Please try again later!",
          color: "error",
        });
      }
    },

    logout() {
      const pollId = localStorage.getItem("pid");
      localStorage.clear();
      localStorage.setItem("pid", pollId);
      this.$router.go();
    },

    async getPollData(id) {
      this.overlay = true;
      const res = await this.makeFetch({
        method: "get",
        goTo: `/polls/${id}`,
        stateVar: "voterData",
      })
        .catch(console.error)
        .finally(() => {
          this.overlay = false;
        });

      if (res && res.success) {
        const { data } = res;
        for (const d in data) {
          if (
            data[d].poll_id == this.$route.params.id ||
            data[d].id == this.$route.params.id
          )
            this.updateCollection({
              cn: d,
              mode: d == "voters" ? "push" : null,
              data: data[d],
            });
        }
      }
    },
  },

  async mounted() {
    const id = this.$route.params.id;

    if (id) {
      await this.getPollData(id);

      const usr = localStorage.getItem("usr");
      const isPasswordSet = JSON.parse(usr).password_set;
      this.dialog = !isPasswordSet;
    }

    await this.makeFetch({
      method: "get",
      goTo: "/polls",
      stateVar: "polls",
    }).catch(console.error);
  },

  async beforeRouteUpdate(to, from, next) {
    next();
    await this.getPollData(to.params.id);
  },
};
</script>
